import { BaseContextType } from '@smx-ui-model/types';

import { drawingSetAnnotationCoreModel } from './drawing-set-annotation-core-model';
import { DrawingSetAnnotationModelSchemaType } from './types';

export const drawingSetAnnotationModel: DrawingSetAnnotationModelSchemaType<BaseContextType> = {
    ...drawingSetAnnotationCoreModel,
    renderData: {},
    action: {},
};
